export interface AdminLoginRequest {
  userName: string;
  password: string;
}

export interface LoginResponse {
  accessToken: string;
  refreshToken: string;
  expiresIn: string;
  userId: number;
  userType: string;
  fullName: string;
  email: string;
}

export interface AuthSession {
  accessToken: string;
  refreshToken: string;
  expiresIn: string;
  userId: number;
  userType: string;
  fullName: string;
  email: string;
}

export const AUTH_STORAGE_KEY = 'vaseline_admin_auth';
